module.exports = __webpack_public_path__ + "assets/img/e46357324c71e6d0a87ac29f9644fb3b.png";